import { Button, ButtonProps } from '@chakra-ui/react'

import { Icon } from '../Icons/Icon'

export const DownloadLink = (props: ButtonProps) => (
  <Button
    variant="tertiary"
    size="md"
    iconSpacing="7px"
    justifyContent="flex-start"
    leftIcon={
      <Icon icon="DownloadIcon" color="presets.turquoise.100" boxSize="16px" />
    }
    overflow="hidden"
    maxWidth="300px"
    textOverflow="ellipsis"
    whiteSpace="nowrap"
    fontSize="12px"
    fontWeight="700"
    {...props}
  />
)
